// extracted by mini-css-extract-plugin
export default {"note-selector":"text-entry_note-selector__MexGx","text-container":"text-entry_text-container__J0lbM","tools":"text-entry_tools__IZ4H0"};